<template>
  <div id="navBar">
    <div class="header">
      <router-link tag="div" to="/" class="navLeft">
        <img src="@/assets/images/logo.png">
      </router-link>
      <div class="navCenter">
        <div class="search">
          <el-input placeholder="请输入内容" v-model="searchText" class="input-with-select"
            @keyup.enter.native="searchInfo('click')" @focus="changeFocus(true)" @blur="changeFocus(false)">
            <el-select v-model="searchType" slot="prepend" placeholder="请选择" @keyup.enter.native="searchInfo('click')">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-button slot="append" class="searchBtn" @keyup.enter.native="searchInfo('click')"
              @click="searchInfo('click')">搜索</el-button>
          </el-input>
          <div class="focusBlock" v-if="isFocus">
            <!-- 这里暂不需要显示搜索记录-->
            <!-- <div class="all" v-show="!searchText">
              <div class="all-left">
                <p>搜索记录</p>
              </div>
              <ul class="all-right">
                <li v-for="(item,index) in searchLogs" :key="index" @click="selectSearchLogs(index)">
                  <span>{{item.searchContent}}</span>
                </li>
              </ul>
            </div> -->
            <div class="all" v-show="searchText">
              <div class="all-left">
                <p>搜索结果</p>
              </div>
              <ul class="all-right">
                <li v-if="searchResults.length == 0"><span>暂无数据</span></li>
                <li v-else v-for="(item, index) in searchResults" :key="index" @mousedown="selectGoods(index)">
                  <span v-html="item.goodsCatalogueIdname"></span>&nbsp;--&nbsp;
                  <span v-html="item.title"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 原来的代码 -->
        <!-- <el-tabs v-model="activeName" @mouseenter.native="coming" @mouseleave.native="leaving" @tab-click="handleTabchange1"> -->
        <!-- 修改后的代码 2023年10月24日12:12:00 -->
        <el-tabs v-model="activeName" @tab-click="handleTabchange1">
          <el-tab-pane v-for="(item, index) in options" :key="index" :label="item.label" :name="item.value">
            <div v-if="item.type === 'TOOLS'">
              <div class="contentBox" v-show="tabisclick">
                <div class="contentLeft">
                  <div>
                    <div class="searchBox" v-on:keydown="changeIndex()" v-on:keydown.enter="selectList">
                      <input type="text" v-model="searchKnowledgeText" class="leftInput" placeholder="请输入搜索内容"
                        @change="searchValueChange" />
                      <div class="searchbtn1 hand">
                        <i class="iconfont icon-sousuo"></i>
                      </div>
                      <div class="SearchResult" v-show="searchKnowledgeText != ''">
                        <div v-show="searchList.length == 0" class="normalResult">没有找到结果，请重新输入</div>
                        <ul class="scrollBox" style="top: 0px;" v-show="searchList.length != 0">
                          <li v-for="(row, index) in searchList" @click="choiceList(index, row)"
                            :class="resultIndex == index ? 'activeResult' : 'normalResult'">
                            {{ row.title }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <ul class="titleList">
                      <li v-for="(item, index) in dictionariesTitleList"
                        :class="item.id === tableftActive ? 'activeLi' : ''"
                        @click="selectDictionariesTitle(index); loadPaneDataChilds(item)">
                        <i :class="'iconfont icon-' + item.icon"></i> <span>{{ item.title }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="contenRight">
                  <!-- <div class="borderRight">
                    <div :class="childMenuId == 'all' ? 'childMenuActive typeName' : 'typeName'"
                      @click="selectLevelThreeAll(); loadPaneDataChilds({ id: tableftActive });">
                      <p>全部</p>
                    </div>
                    <div v-for="(item, index) in physicochemicalList" v-show="item.pid == tableftActive"
                      :class="childMenuId === item.id ? 'childMenuActive typeName' : 'typeName'"
                      @click="loadPaneDataChilds(item); childMenuId = item.id">
                      <p>{{ item.title }}</p>
                    </div>
                  </div> -->
                  <div class="flex1 borderRight technology">
                    <div v-for="(item, index) in paneDataChilds" @click="showDetail(item.id, '2')">
                      <p>{{ item.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="contentBox" v-show="tabisclick">
                <div class="contentLeft">
                  <div>
                    <div class="searchBox" v-on:keydown="changeIndex()" v-on:keydown.enter="selectList">
                      <input type="text" v-model="searchKnowledgeText" class="leftInput" placeholder="请输入搜索内容123"
                        @change="searchValueChange" />
                      <div class="searchbtn1 hand">
                        <i class="iconfont icon-sousuo"></i>
                      </div>
                      <div class="SearchResult" v-show="searchKnowledgeText != ''">
                        <div v-show="searchList.length == 0" class="normalResult">没有找到结果，请重新输入</div>
                        <ul class="scrollBox" style="top: 0px;" v-show="searchList.length != 0">
                          <li v-for="(row, index) in searchList" @click="choiceList(index, row)"
                            :class="resultIndex == index ? 'activeResult' : 'normalResult'">
                            {{ row.catalogueName }}--{{ row.title }}--{{ row.no }}
                          </li>
                        </ul>
                      </div>

                    </div>
                    <ul class="titleList borderRight">
                      <li v-for="(item, index) in dictionariesTitleList"
                        :class="item.id === tableftActive ? 'activeLi' : ''" @click="selectDictionariesTitle(index)">
                        <i :class="'iconfont icon-' + item.icon"></i> <span>{{ item.title }}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="contenRight">
                  <div class="borderRight">
                    <!-- @zz 修改 2023年11月28日16:20:32 -->
                    <!-- <div :class="childMenuId == 'all' ? 'childMenuActive typeName' : 'typeName'"
                      @click="selectLevelThreeAll()">
                      <p>全部</p>
                    </div> -->
                    <div v-for="(item, index) in physicochemicalList" v-show="item.pid == tableftActive"
                      :class="childMenuId == item.id ? 'childMenuActive typeName' : 'typeName'"
                      @click="selectLevelThree(index)">
                      <p>{{ item.title }}</p>
                    </div>
                  </div>
                  <div class="flex1 childMenu borderRight" v-if="childMenuId == 'all'">
                    <div v-for="(item, index) in physicochemicalList" v-if="item.pid == tableftActive">
                      <div style=" height: 100%;">

                        <div class="borderRight">
                          <div v-for="(items, index1) in item.list">
                            <div class="detailList">
                              <p><span @click="showDetail(items.id, '1')">{{ items.title }}</span></p>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="flex1 childMenu borderRight" v-else>
                    <div v-for="(item, index) in physicochemicalList" v-if="childMenuId == item.id">
                      <!-- @zz 修改 2023年11月28日16:20:32 -->
                      <div style="display: flex;flex-direction: column;height: 100%;">
                        <div class="borderRight">
                          <div v-for="(items, index1) in item.list">
                            <div class="detailList">
                              <p><span @click="showDetail(items.id, '1')">{{ items.title }}</span></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="navRight">
        <login-area></login-area>
      </div>
    </div>
  </div>
</template>

<script>
import loginArea from '@/components/loginArea'
export default ({
  name: "navBar",
  components: {
    loginArea
  },
  data() {
    return {

      /*************** 新增属性 2023年11月18日15:38:46  *****************/

      // list_GoodsCatalogue: [],
      searchGoodsType: 0,

      /*****************************************************************/

      showdefaultphoto: this.$store.state.userImage === null || this.$store.state.userImage === undefined || this.$store
        .state.userImage === '' ? false : true, //是否有头像 true表示有
      searchText: '',
      searchType: '',
      isFocus: false, //搜索框焦点
      searchResults: [], //动态搜索结果
      searchLogs: [], //搜索历史
      isActive: "",
      options: [],
      activeName: 'zero', //设置成不存在的activeName 实现进入页面不展开tabcontent
      tableftActive: '', //页签面版左侧选中项
      come: false, //鼠标默认未进入
      leave: false, //鼠标默认离开
      titleList: [],
      dictionariesTitleList: [], //平台下拉面板2级菜单（左侧）
      physicochemicalList: [], //平台下拉面板3级菜单（右侧）
      clickOneColumn: false, //是否展示某一列 默认全部展示
      theOneColumns: [], //点击某一行的数据
      searchKnowledgeText: '', //知识搜索文本框
      resultIndex: '0', //点击搜索出的内容时 对应的index，

      paneDataChilds: [], //下拉面板已上架商品数据
      //搜索出来的内容的模拟数据
      searchList: [],
      childMenuId: "", //二级菜单下，控制三级菜单显示的id
      lastClickTabId: "", //上一个选中页签id
      tabisclick: false, //tab平台页签点击标识
    }
  },
  watch: {
    // 如果 `searchKnowledgeText` 发生改变，这个函数就会运行
    searchKnowledgeText: function (newText, oldText) {
      this.searchValueChange();
    },
    // 如果 `searchText` 发生改变，这个函数就会运行
    searchText: function (newsearchText, oldsearchText) {
      console.info('searchText', newsearchText, this.searchType)
      if (newsearchText) { //有值才触发自动搜索
        this.searchInfo('auto');
      }
    },
  },
  created: function () { //登录后的状态数据 ，前台手动加，后台联调后删除这个方法
    this.searchText = '';
    this.searchType = '';
    var params = {
      url: "/SJHG/publicplat/home/home/initHomeDisplayData",
      data_: {}
    };
    this.axiosPost(params, this.loadAxiosPostData); //初始化加载商品目录
    if (this.$route.query.tabId) {
      this.activeName = this.$route.query.tabId;
      this.handleTabchange1();
    }
    document.documentElement.style.overflowY = 'scroll';
  },
  methods: {
    //初始化查询参数
    initSearchParams: function (params) {
      this.searchText = params.searchText == undefined ? '' : params.searchText;
      this.searchType = params.searchType == undefined ? '' : params.searchType;
    },
    changeFocus(val) { //切换搜索框焦点
      this.isFocus = val;
    },
    handleTabchange1: function (tab, event) { //切换平台
      //切换平台清空查询值与结果
      this.searchKnowledgeText = '';
      this.searchList = [];
      this.dictionariesTitleList = [];
      this.physicochemicalList = [];

      if (this.lastClickTabId == this.activeName) {
        if (this.tabisclick) {
          this.tabisclick = false;
          document.documentElement.style.overflowY = 'scroll';
        } else {
          this.tabisclick = true;
          document.documentElement.style.overflowY = 'hidden';
        }
      } else {
        this.tabisclick = true;
        document.documentElement.style.overflowY = 'hidden';
      }
      //记录本次选中页签
      this.lastClickTabId = this.activeName;
      /* this.activeName = tab.name; //获取到当前元素的name */
      //根据选中tab加载面板数据
      if (this.activeName == '15562339') { //数据字典面板选中跳转公式页面其它跳转商品页面
        this.setTitleList(this.activeName, this.setDictionariesTitleList);
      } else {
        this.loadTabPaneData(this.activeName, this.setTabPaneData);
      }
    },
    //异步请求
    axiosPost: function (params, successCallback) {
      let this_ = this;
      let paramdata = {};
      paramdata.url = params.url;
      paramdata.data = params.data_; //json对象
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var resultdata = res.data.result;
          successCallback(resultdata);
        } else {
          console.log(res);
        }
      };
      paramdata.onFailed = function (res) {
        console.log(res);
      };
      this_.$axiosUtil.postServer(paramdata);
    },
    loadAxiosPostData: function (resultdata) {
      //加载异步请求结果
      let list_GoodsCatalogue = resultdata.list_GoodsCatalogue; //知识商品目录
      //加载搜索框下拉选项
      this.setOptions(list_GoodsCatalogue);

      //当前登录人搜索记录
      var list_logsGoodsSearch = resultdata.list_logsGoodsSearch;
      this.searchLogs = list_logsGoodsSearch;
    },
    setCatalogue: function (data_) {
      //设置知识目录
      this.catalogue = data_;
    },
    setOptions: function (data_) {
      //设置搜索框下拉选项
      data_.forEach(item => {
        this.options.push({
          label: item.name,
          value: item.id,
          type: item.type,
        });
      });
    },
    //鼠标进入方法
    coming() {
      this.come = true;
    },
    //鼠标离开方法
    leaving(tag) {
      this.leave = true;
      if (this.come == true && this.leave == true) {
        this.activeName = "zero";
        this.come = false;
        this.leave = false;
        this.tabisclick = false;
      }
    },
    //调用引用页面的搜索实现方法
    searchInfo(f) {
      let this_ = this;
      let searchText = this_.searchText;
      let searchType = this_.searchType;
      // //校验搜索信息
      if (searchType == '' && (searchText === '' || searchText.length === 0)) {
        this_.$message.info('请录入搜索信息');
        return;
      }

      if (f == 'click') {

        /********* @zz 修改（新增）当搜索结果属于化学化工物料数据则跳转第一个搜索结果 2023年12月2日 *********/ 
        if (this_.searchGoodsType === 1) {
          this.showDetail(this.searchResults[0].id, '1')
          return;
        }
        /************** 结束 ************/ 

        //保存搜索历史（点击搜索、搜索历史、热搜）
        this_.saveSearchLogs(searchText);
        this_.searchInfoByParent(searchText, searchType);
        this.tabisclick = false;
      } else if (f == 'auto') {
        //自动搜索
        //更新查询参数
        let data_ = {
          'pageNo': this_.pageNo,
          'pageSize': this_.pageSize,
          'searchText': this_.searchText,
          'searchType': this_.searchType,
          "savelog": f
        };

        //组装查询
        let paramdata = {};
        paramdata.url = '/SJHG/publicplat/home/home/searchGoodsList';
        paramdata.data = data_; //json对象

        paramdata.onSuccess = function (res) {
          if (res.data.ok) {
            let resultdata = res.data.result;
            let datalist = resultdata.page.list;
            let searchResults_ = [];


            if (datalist && datalist.length > 0) {
              this_.searchGoodsType = 0;
              datalist.forEach(item => {
                let goodsCatalogueIdname = item.goodsCatalogueId.name == undefined ? '' : item.goodsCatalogueId
                  .name;
                let newTitle = this_.newStr(searchText, item.name);
                // var newGoodsCatalogueIdname = this_.newStr(searchText, goodsCatalogueIdname);
                searchResults_.push({
                  'id': item.id,
                  'goodsCatalogueIdname': goodsCatalogueIdname,
                  'title': newTitle,
                  'name': item.name
                });
              });
              this_.searchResults = searchResults_;
            } else {
              // TODO 查询结果为空,继续查询化学化工物性数据
              console.log('开始查询化学化工物性数据');
              paramdata.url = '/SJHG/publicplat/home/home/getQueryTreeDataList';
              data_.rootid = 15562339;
              paramdata.onSuccess = function (res) {
                if (res.data.ok) {
                  let resultdata = res.data.result;
                  let searchResults_ = [];
                  if (resultdata.length > 0) {
                    this_.searchGoodsType = 1;
                    // console.log("查询化学化工物性数据成功", res.data);
                    resultdata.forEach(item => {
                      let goodsCatalogueIdname = item.catalogueName == undefined ? '' : item.catalogueName;
                      let newTitle = this_.newStr(searchText, item.title);
                      let newGoodsCatalogueIdname = this_.newStr(searchText, goodsCatalogueIdname);
                      searchResults_.push({
                        'id': item.id,
                        'goodsCatalogueIdname': newGoodsCatalogueIdname,
                        'title': newTitle,
                        'name': item.catalogueName
                      });
                    });
                    this_.searchResults = searchResults_;
                  }
                } else {
                  // console.log('查询化学化工物性数据失败');
                  this_.searchResults = []
                }
              }
              this_.$axiosUtil.postServer(paramdata);
            }
          } else {
            console.log('查询商品失败');
          }
        };
        paramdata.onFailed = function (res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);

      }
    },
    //高亮显示搜索文本
    //searchText搜索的文本 target被匹配的项
    newStr(searchText, target) {
      let replaceReg = new RegExp(searchText, 'g'); // 匹配关键字正则
      let replaceString = "<a class='searchText'>" + searchText + "</a>";
      let newStr = target.replace(replaceReg, replaceString);
      return newStr
    },
    searchInfoByParent(searchText_, searchType_) {
      this.$emit('searchInfo', {
        'searchText': searchText_,
        'searchType': searchType_
      });
    },
    selectGoods(selectIndex) { //选中搜素记录商品跳转商品查看页面
      console.log("搜索: ", selectIndex);
      this.tabisclick = false;
      let searchText_ = this.searchResults[selectIndex] == undefined ? '' : this.searchResults[selectIndex].name;
      //保存搜搜索记录
      this.saveSearchLogs(searchText_);
      this.searchInfoByParent(searchText_, this.searchType);
      this.searchText = this.searchResults[selectIndex].searchContent;
      this.isFocus = false;

      if (this.searchGoodsType === 1) {
        this.showDetail(this.searchResults[selectIndex].id, '1')
      } else {
        this.showDetail(this.searchResults[selectIndex].id, '2')
      }

    },
    selectSearchLogs(selectIndex) { //选中搜索历史
      let searchText_ = this.searchLogs[selectIndex] == undefined ? '' : this.searchLogs[selectIndex].searchContent;
      this.saveSearchLogs(searchText_);
      this.searchInfoByParent(searchText_, '');
      this.searchText = this.searchLogs[selectIndex].searchContent;
      this.isFocus = false;
    },
    saveSearchLogs(searchText_) { //保存搜索历史
      //有账号登录且搜索文本不空才存搜索历史
      if (!this.$store.state.userId || !searchText_) return;
      //保存搜搜索记录
      let paramdata = {};
      paramdata.url = '/SJHG/publicplat/home/home/saveLogsGoodsSearch';
      paramdata.data = {
        'searchText': searchText_,
        'savelog': 'click'
      }; //json对象
      paramdata.onSuccess = function (res) { };
      paramdata.onFailed = function (res) { };
      this.$axiosUtil.postServer(paramdata);
    },
    //根据选中tab加载面板数据
    loadTabPaneData: function (catalogueId, callback) {
      var params = {
        url: "/SJHG/publicplat/home/home/getGoupCatalogueTreeData",
        data_: {
          'catalogueId': catalogueId,
        }
      };
      this.axiosPost(params, callback);
    },
    //根据选中目录id加载已上架商品
    loadPaneDataChilds: function (item) {

      let this_ = this;
      let paramdata = {
        url: "/SJHG/publicplat/home/home/getGoupCatalogueTreeDataChilds",
        data: {
          'catalogueId': item.id
        }
      };
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          let resultdata = res.data.result;
          let paneDataChilds = [];
          resultdata.map((item, index) => {
            paneDataChilds.push({
              title: item.name,
              id: item.id
            });
          });

          this_.paneDataChilds = paneDataChilds;
          if (this_.physicochemicalList.length === 0 || item.id === this_.tableftActive) {
            this_.childMenuId = 'all'
          }
        } else {
          console.log(res);
        }
      };
      paramdata.onFailed = function (res) {
        console.log(res);
      };
      this_.$axiosUtil.postServer(paramdata);
    },
    //加载下拉面板数据
    setTabPaneData: function (data_) {
      // console.log(data_);
      let nodelist = data_.childrens;  // 一级列表
      let dictionariesTitleList = []; // 二级列表
      let physicochemicalList = [];   // 三级列表
      if (nodelist === undefined || nodelist.length === 0) {
        //清空二级title
        this.dictionariesTitleList = [];
        //清空三级title
        this.physicochemicalList = [];
      } else {
        nodelist.map((item, index) => {
          let name = item.name;
          if (item.total) {
            name = name + " (" + item.total + ")"
          }
          dictionariesTitleList.push({
            title: name,
            id: item.id,
            pid: item.parentId,
            pids: item.parentIds,
            icon: "yunjisuan"
          });

          //左侧菜单(设置二级title)选中id
          let tableftActive = '';
          if (dictionariesTitleList.length > 0) {
            tableftActive = dictionariesTitleList[0].id;
          } else {
            tableftActive = '';
          }
          this.tableftActive = tableftActive;
          //设置二级title
          this.dictionariesTitleList = dictionariesTitleList;
          //递归叠右侧三级及以上菜单
          physicochemicalList = physicochemicalList.concat(this.loadchildrens(item));
        });
      }
      //设置三级title
      this.physicochemicalList = physicochemicalList;
      this.childMenuId = this.dictionariesTitleList[0].id; // 默认显示第二级菜单第一项全部

      if (this.childMenuId) {
        this.loadPaneDataChilds({ id: this.childMenuId });
      } else {
        if (this.tableftActive) {
          this.loadPaneDataChilds({ id: this.tableftActive });
        }
      }
    },

    //查询字典数据
    setTitleList: function (data_, callback) {
      var params = {
        url: "/SJHG/publicplat/home/home/getTreeData",
        data_: {
          'rootid': data_,
          'type': 'MATERIEL'
        }
      };
      this.axiosPost(params, callback);
    },
    setDictionariesTitleList: function (data_) {

      // console.log(data_);

      let nodelist = data_.childrens;
      let dictionariesTitleList = [];
      let physicochemicalList = [];
      if (nodelist === undefined || nodelist.length === 0) {
        //清空二级title
        this.dictionariesTitleList = [];
        //清空三级title
        physicochemicalList = [];
      } else {

        nodelist.map((item, index) => {
          // console.log(item);
          dictionariesTitleList.push({
            title: item.name,
            id: item.id,
            pid: item.parentId,
            pids: item.parentIds,
            icon: "yunjisuan"
          });

          //左侧菜单(设置二级title)选中id
          let tableftActive = '';
          if (dictionariesTitleList.length > 0) {
            tableftActive = dictionariesTitleList[0].id;
          } else {
            tableftActive = '';
          }
          this.tableftActive = tableftActive;
          //设置二级title
          this.dictionariesTitleList = dictionariesTitleList;
          //递归叠右侧三级及以上菜单
          physicochemicalList = physicochemicalList.concat(this.loadchildrens(item));
        });

      }

      // console.log("aaa",this.tableftActive);

      //设置三级title
      this.physicochemicalList = physicochemicalList;

      // console.log("physicochemicalList:", physicochemicalList); // 调试输出

      if (this.physicochemicalList.length > 0 && this.physicochemicalList[0].id) { //设置默认显示三级菜单的第一项
        this.childMenuId = this.physicochemicalList[0].id;
      }
    },
    //递归叠3级及以上菜单
    loadchildrens: function (item) {
      let this_ = this;
      let childrens = item.childrens;
      let objList = [];

      if (childrens != undefined && childrens.length > 0) {
        childrens.map((c_item, c_index) => {
          objList.push({
            title: c_item.name,
            id: c_item.id,
            pid: c_item.parentId,
            pids: c_item.parentIds,
            list: this_.loadchildrens(c_item),
            icon: "yunjisuan"
          });
        });
      } else {
        //当前节点有物料信息
        if (item.knowledgeId) {
          objList.push({
            title: item.knowledgeName,
            id: item.knowledgeId,
            pid: item.id,
            pids: item.parentIds + item.id + ",",
            list: [],
            icon: "yunjisuan"
          });
        }
      }
      return objList;
    },

    selectDictionariesTitle: function (index) {
      //选中二级菜单触发事件
      let selected = this.dictionariesTitleList[index];
      this.tableftActive = selected.id;
      var i = this.physicochemicalList.findIndex((value, index, arr) => {
        return value.pid == selected.id;
      })
      if (i > -1) {
        this.childMenuId = this.physicochemicalList[i].id;
      } else {
        this.childMenuId = "";
      }
    },

    selectLevelThree(index) { //选中三级菜单
      let selected = this.physicochemicalList[index];
      this.childMenuId = selected.id;
    },

    selectLevelThreeAll(index) { //选中三级菜单全部
      this.childMenuId = 'all';
    },

    /**
     * @param {number} index 点击的列表下标
     * @param {number} length 所点击的列表包含的项
     */
    showMore1: function (item) {
      if (this.clickOneColumn) {
        this.clickOneColumn = false;
      } else {
        this.clickOneColumn = true;
      }
      this.isActive = item.id;
      this.theOneColumns = item.list;
    },
    showDetail(val, type) { //商品详情  type:1商品详情  2物料详情
      this.activeName = 'zero'
      if (type === '1') {
        this.$router.push({
          path: "/algorithmDetail",
          query: {
            "id": val
          }
        });
      } else if (type === '2') {
        this.$router.push({
          path: "/toolKnowledgeDetails",
          query: {
            "id": val
          }
        }).catch(err => {
          console.error(err);
          this.activeName = "zero";
        })
      }
    },
    // searchKnowledge() { //搜索知识
    //   let this_ = this;
    //   //1.目录id
    //   let muid = this_.activeName;
    //   //2.搜索文本
    //   let searchText = this_.searchKnowledgeText;
    //   // console.log(muid + "  " + searchText);
    // },

    //数字字典内搜索框值改变事件
    searchValueChange() {
      let this_ = this;
      if (this_.searchKnowledgeText === '') {
        this_.searchList = [];
        return;
      }
      var params = {
        url: "/SJHG/publicplat/home/home/getQueryTreeDataList",
        data_: {
          rootid: this_.activeName,
          searchText: this_.searchKnowledgeText
        }
      };
      var callback_ = function (data_) {
        // 调用 callback 返回建议列表的数据
        this_.searchList = data_;
      };
      this_.axiosPost(params, callback_); //初始化加载商品目录
    },
    //键盘按上下键时，选中搜索结果列表中的某一项
    changeIndex() {
      var e = window.event || event;
      var boxa = document.getElementsByClassName("SearchResult")[0];
      if (e.keyCode == 40) { //键盘按下的键为下
        /* console.log("下键"); */
        if (this.resultIndex < (this.searchList.length - 1)) {
          this.resultIndex++;
          var topDistance = boxa.scrollTop
          if (this.resultIndex > 5 && this.resultIndex < this.searchList.length) {
            boxa.scrollTop = parseFloat(topDistance) + 35;
          }
        }
      } else if (e.keyCode == 38) { //键盘按下的键为上
        /* console.log("上键") */
        if (this.resultIndex > 0) {
          this.resultIndex--;
          if (this.resultIndex > 4 && this.resultIndex < this.searchList.length) {
            boxa.scrollTop = parseFloat(boxa.scrollTop) - 35;
          }
        }
      }
    },
    //键盘按下enter键时，选中搜索匹配的列表滚动到的项
    selectList() {
      if (this.searchList.length == 0) return;
      this.choiceList(this.resultIndex, this.searchList[this.resultIndex]);
    },
    //鼠标点击选择搜索匹配出的内容项
    choiceList(index, row) {
      this.resultIndex = index;
      if (this.activeName == '15562339') { //数据字典面板选中跳转公式页面其它跳转商品页面
        this.showDetail(row.id, '1');
      } else {
        this.showDetail(row.id, '2');
      }

      this.searchList = [];
    }
  }
})
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

#navBar {
  background: #252B3A;
  height: 130px;
  position: relative;
}

.header {
  // width: 1280px;
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-top: 20px;
  padding-bottom: 2px;
  background: #252B3A;
}

.navLeft img {
  cursor: pointer;
  height: 85px;
  margin: auto;
}

.navLeft,
.navRight {
  width: 25%;
  display: flex;
}

.navCenter {
  width: 50%;
}

.user img {
  width: 40px;
  height: 40px;
}

.navCenter>>>.el-input--suffix {
  width: 100px;
}

.navCenter>>>.el-input__inner {
  border: none;
}

.navCenter>>>.el-input-group__append {
  border: 0;
}

.user {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 20px;
}

.navRight {
  justify-content: center;
  align-items: center;
}

.user>div {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.user p {
  color: #fff;
  font-size: 14px;
  margin-left: 5px;
}

.icon-xiaoxi {
  color: #fff;
  font-size: 20px;
}

.searchBtn {
  background: $color-primary !important;
  color: #fff !important;
  border-radius: 0 !important;
  padding: 13px 20px;
}

.header>>>.el-tabs__content {
  position: absolute;
  left: 0;
  // top: 100%;
  width: 100%;
  z-index: 100;
}

.header>>>.el-input-group__prepend {
  border-radius: 0;
}

.header>>>.el-input-group__append {
  border-radius: 0;
}

.header>>>.el-tabs__item {
  color: #fff;
  font-size: 16px;
  height: 50px;
}

.header>>>.el-tabs__item:hover {
  color: $color-primary;
}

.header>>>.el-tabs__nav-wrap::after {
  height: 0;
}

.header>>>.el-tabs__item.is-active {
  color: $color-primary;
}

.header>>>.el-tabs__active-bar {
  background: $color-primary;
  bottom: 1px;
}

.header>>>.el-tabs__header {
  margin: 15px 0 0 0;
}

.contentBox {
  display: flex;
  flex-direction: row;
  position: relative;
  height: calc(100vh - 120px);
  box-sizing: border-box;
}

.contentLeft {
  width: 25%;
  background: #1D222E;
  padding: 15px 0px 0px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.contenRight {
  width: 75%;
  height: calc(100vh - 120px);
  padding: 90px 0 0 10px;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
}

.leftInput {
  box-sizing: border-box;
  width: 100%;
  height: 35px;
  background: #252B3A;
  border: none;
  padding: 0 30px 0 5px;
  color: #fff;
  outline: none;
}

.search {
  position: relative;
  z-index: 1000;
}

.searchBox {
  width: 90%;
  position: relative;
}

.searchBox .el-autocomplete {
  box-sizing: border-box;
  width: 100%;
}

.searchBox .el-autocomplete>>>.el-input__inner {
  height: 35px;
  background: #252B3A;
  border: none;
  padding: 0 30px 0 5px;
  color: #fff;
}

.searchbtn1 {
  width: 35px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  position: absolute;
  top: 0;
  right: 0;
}

.searchbtn1 i {
  color: #A0A2A8;
}

.searchbtn1 i:hover {
  color: #f66f6a;
  cursor: pointer;
}

.leftInput::-webkit-input-placeholder {
  color: #A0A2A8;
}

.titleList {
  margin-top: 20px;
  height: calc(100vh - 190px);
  overflow-y: auto;
  padding-right: 30px;
  border-right: 1px solid #2F3845;

}

.titleList li {
  padding: 20px 0 20px 10px;
  color: #ffffffba;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.titleList li i {
  font-size: 20px;
  margin-right: 10px;
}

.titleList .activeLi {
  background: #212734;
  color: $color-primary;
}

.titleList::-webkit-scrollbar,
.contenRight div::-webkit-scrollbar {
  width: 5px;
}

.titleList::-webkit-scrollbar-track {
  background: #2F3845;
}

.contenRight div::-webkit-scrollbar {
  background: #252B3A;
}

.titleList::-webkit-scrollbar-thumb,
.contenRight div::-webkit-scrollbar-thumb {
  background: #c1c1c1;
}

.titleList::-webkit-scrollbar-button,
.contenRight div::-webkit-scrollbar-button {
  display: none;
}

.contenRight>div:first-child {
  padding: 0px 10px;
  width: 28%;
  box-sizing: border-box;
  overflow-y: auto;
}

.flex1 {
  flex: 1;
}

.borderRight {
  border-right: 1px solid #2F3845;
}

.typeName p {
  /* text-align: center; */
  font-size: 14px;
  padding: 0 0 2px;
  border-bottom: 1px solid #212634;
  margin-bottom: 18px;
  cursor: pointer;
  color: #ffffffba;
  display: inline-block;
}

.typeName:hover p {
  border-bottom: 1px solid #f66f6a;
  color: #f66f6a;
}

.childMenuActive p {
  border-bottom: 1px solid #f66f6a;
  color: #f66f6a;
}

.lines {
  color: #ffffffba;
  border-left: 2px solid #ffffffba;
  font-size: 14px;
  line-height: 14px;
  padding: 2px 8px;
}

.detailList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 15px;
  padding-left: 10px;
}

.detailList p {
  margin-right: 30px;
  margin-bottom: 15px;
  color: #ffffff6b;
  font-size: 14px;
}

.detailList p>span:hover {
  color: #f66f6a;
  cursor: pointer;
}

.titleList li:hover {
  background: #212734;
  color: $color-primary;
  cursor: pointer;
}

/* 后期修改页面 */
.typeName>span:hover {
  color: #f66f6a;
  cursor: pointer;
}

.typeName.active {
  color: #f66f6a;
  background: #212734;
}

// .typeName.active i{

// }

.typeName i {
  transform: rotate(0deg);
  display: inline-block;
}

.icon-down2 {
  margin-left: 5px;
}

.showMore {
  text-align: center;
  color: #fff;
  font-size: 14px;
}

.showMore span {
  cursor: pointer;
}

.showMore span:hover {
  color: #f66f6a;
}

.contentBox>.justOneColumn {
  position: absolute;
  top: 60px;
  left: 25%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: calc(100% - 100px);
  padding: 19px 20px 0;
  width: calc(75% - 40px);
  align-content: baseline;
}

.contentBox>.justOneColumn>div {
  width: calc((100%/3) - 30px);
  margin-right: 10px;
}

.hand {
  // cursor: pointer;
}

.SearchResult {
  position: absolute;
  top: 35px;
  left: 0px;
  color: #fff;
  background: rgb(37, 43, 58);
  width: 100%;
  height: 210px;
  overflow-y: auto;
}

.SearchResult li:hover {
  cursor: pointer;
}

.activeResult {
  color: rgb(246, 111, 106);
  padding: 8px 10px;
  background: #0c1326;
  font-size: 14px;
}

.normalResult {
  color: #fff;
  padding: 8px 10px;
  font-size: 14px;
}

.normalResult:hover {
  background: #0c1326;
  color: rgb(246, 111, 106);
}

.scrollBox {
  position: relative;
  left: 0px;
}

.SearchResult::-webkit-scrollbar {
  width: 4px;
  background: rgb(33, 38, 52);
}

.SearchResult::-webkit-scrollbar-thumb {
  background: rgb(136, 136, 136);
  width: 4px;
  border-radius: 4px;
  height: 6px;
}

.SearchResult::-webkit-scrollbar-track {
  background: rgb(37, 43, 58);
}

.searchBox>>>.el-input__inner {
  border-radius: 0px;
  padding: 4px 8px;
  line-height: auto;
  height: 35px;
}

//2019.12.23 jdy
.firstContenRight {
  width: 75%;
  padding: 0px;
  padding-top: 6px;
}

.firstContenRight>>>.el-tabs__header {
  margin-top: 0px;
}

.firstContenRight>>>.el-tabs--border-card {
  background: rgb(33, 39, 52);
  border-color: rgb(33, 39, 52);
  width: 100%;
}

.firstContenRight>>>.el-tabs--border-card>.el-tabs__header {
  background: rgb(33, 39, 52);
  border: none;
}

.firstContenRight>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  background: rgb(33, 39, 52);
  border-color: rgb(33, 39, 52);
}

.firstContenRight>>>.el-tabs--border-card>.el-tabs__content {
  padding: 0px 0px 0px 20px;
}

.firstContenRight>>>.el-tabs__content {
  width: 100%;
  position: relative;
  color: #A0A2A8;
}

.firstContenRight>>>.el-tabs__item {
  color: #A0A2A8;
}

.contair {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.contairLi {
  width: 40%;
  display: flex;
}

.contairLi .icon-resou {
  color: #F66F6A;
  margin-top: -20px;
}

.contairLi>div:first-of-type {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.contairLi>div:last-of-type {
  height: 40px;
  color: #A0A2A8;
}

.firstContenRight .contairLi div {
  cursor: pointer;
  color: #FFF;
}

.firstContenRight .contairLi div:hover {
  cursor: pointer;
  color: #F66F6A;
}

.focusBlock {
  position: absolute;
  width: 100%;
  background: #fff;
  left: 0;
  border: 1px solid $color-primary;
  box-sizing: border-box;
  max-height: 500px;
}

.all {
  display: flex;
  flex-direction: row;
  z-index: 100;
}

.all-left {
  width: 100px;
  border-right: 1px solid $color-primary;
  font-size: 14px;
  display: flex;
  max-height: 500px;
}

.all-left p {
  margin: auto;
}

.all-right {
  flex: 1;
  padding: 2px;
  max-height: 500px;
  overflow-y: auto;
}

.all-right li {
  color: #606266;
  padding: 10px;
}

.all-right li:hover {
  color: #fff;
  background: $color-primary;
  cursor: pointer;
}

.all-right li span:first-child {
  color: #FFA128;
}

.childMenu {
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  padding-left: 20px;
}

.childMenu>div {
  flex: 1;
}

>>>.el-tabs__content {
  width: 100%;
  background: #1D222E;
}

>>>.el-tab-pane {
  width: 1280px;
  margin: 0 auto;
}

.all ul li>>>.searchText {
  color: #f66f6a;
}

.all ul li:hover>>>.searchText {
  color: #ffffff;
}

.technology {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;

  >div {
    width: 25% !important;
    padding: 0 15px 15px;
    box-sizing: border-box;

    p {
      color: #ffffff6b;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: $color-primary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue